function CardSection(){
    return(<div className="flex flex-col xl:flex-row mx-[40px] xl:mx-[80px] text-left justify-center items-center lg:items-end gap-[24px] text-white">
        <div className="w-full flex flex-col justify-center text-left bg-[#226884] pt-[32px] pb-[32px] xl:pb-[200px] px-[32px] rounded-[16px] xl:hover:mt-[64px] xl:hover:pb-[136px] transition-all duration-500">
            <p className="text-[12px]">Orqestra Starter / Pro</p>
            <h1 className="text-[20px] font-semibold">Unified Omnichannel Inbox</h1>
            <p>Manage WhatsApp, Instagram, and Web chats in one single dashboard. No more switching apps.</p>
        </div>
        <div className="w-full flex flex-col justify-center text-left bg-[#296F4B] pt-[32px] pb-[32px] xl:pb-[136px] px-[32px] rounded-[16px] xl:hover:pb-[200px] transition-all duration-500">
            <p className="text-[12px]">Orqestra Pro</p>
            <h1 className="text-[20px] font-semibold">Automated Chatbots</h1>
            <p>Provide 24/7 customer support. Automatically answer FAQs, share catalogs, and take initial order details.</p>
        </div>
        <div className="w-full flex flex-col justify-center text-left bg-[#BA7852] pt-[32px] pb-[32px] xl:pb-[200px] px-[32px] rounded-[16px] xl:hover:mt-[64px] xl:hover:pb-[136px] transition-all duration-500">
            <p className="text-[12px]">Custom Web Dev</p>
            <h1 className="text-[20px] font-semibold">Custom Web Applications</h1>
            <p>Build lightweight, fast-loading landing pages and e-catalogs that perfectly represent your brand identity.</p>
        </div>
        <div className="w-full flex flex-col justify-center text-left bg-[#5D4B8C] pt-[32px] pb-[32px] xl:pb-[128px] px-[32px] rounded-[16px] xl:hover:pb-[200px] transition-all duration-500">
            <p className="text-[12px]">Orqestra Starter / Pro</p>
            <h1 className="text-[20px] font-semibold">Role-Based Team Access</h1>
            <p>Allow multiple staff members to handle customer chats simultaneously from different devices without buying extra phones.</p>
        </div>
    </div>)

}

export default CardSection